import { observer } from "mobx-react-lite";
import "../styles/calculator.css";
import SwitcherParams from "../components/ui/SwitcherParams";
import Dropbox from "../components/ui/Dropbox";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import calculator_fields from "../settings/calculator.json";
import primary_fields from "../settings/primary.json";
import bank_fields from "../settings/bank.json";
import loan_fields from "../settings/loans.json";
import fta_fields from "../settings/fta.json";
import useMainKeeper from "../hooks/useMainKeeper";
import usePrimary from "../hooks/usePrimary";
import MultiSwitcherStage from "../components/ui/MultiSwitcherStage";
import useBank from "../hooks/useBank";
import usePayday from "../hooks/usePayday";
import Clicker from "../components/ui/Clicker";
import useRateOptions from "../hooks/useRateOptions";
import useFta from "../hooks/useFta";
import { Context } from "..";

const Calculator = () => {

    const { store } = useContext(Context);

    const [isOpenedDropbox, setIsOpenedDropbox] = useState(null);
    const [dropboxes, setDropboxes] = useState({
        viewOfOrganization: {
            values: calculator_fields.viewOfOrganization,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        taxationSystem: {
            values: calculator_fields.taxationSystem,
            defaultValue: 0,
            currentValue: 1,
            isOpened: false
        },
        mainKeeperMove: {
            values: calculator_fields.mainKeeperMove,
            defaultValue: 0,
            currentValue: 1,
            isOpened: false
        },
        megaPriceOfCountDocuments: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        typeActivity: {
            values: [],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        primaryMegaPriceOfCountDocuments: {
            values: primary_fields.docs_count,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        primaryMegaPriceOfTimeLimit: {
            values: primary_fields.time_limit,
            defaultValue: 0,
            currentValue: 1,
            isOpened: false
        },
        bankMegaPriceOfStatements: {
            values: bank_fields.bank_statements,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        bankMegaPriceOfTimeLimit: {
            values: bank_fields.time_limit,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        paydayRange: {
            values: [
                { "name": "1", "value": 1 },
                { "name": "2-5", "value": 5 },
                { "name": "6-10", "value": 10 },
                { "name": "11-15", "value": 15 },
                { "name": "16-20", "value": 20 },
            ],
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        ftaMegaPriceOfCountDocuments: {
            values: fta_fields.docs_count,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        fatMegaPriceOfTimeLimit: {
            values: fta_fields.time_limit,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
        loans: {
            values: loan_fields.docs_count,
            defaultValue: 0,
            currentValue: 0,
            isOpened: false
        },
    });
    const changeOpenedDropbox = (dropboxName, state) => {
        let newDropboxes = { ...dropboxes };
        if (isOpenedDropbox != null) newDropboxes[isOpenedDropbox].isOpened = false;
        setDropboxes({ ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], isOpened: state } });

        if (state) setIsOpenedDropbox(dropboxName);
        else setIsOpenedDropbox(null);
    }
    const changeValueDropbox = (dropboxName, value) => {
        let newDropboxes = { ...dropboxes };
        newDropboxes[isOpenedDropbox].isOpened = false;
        newDropboxes[dropboxName].currentValue = value;
        setDropboxes(newDropboxes);
    }


    const { mk_orgranization, mk_difficulty_docs, mk_difficulty_activity, mk_summ, mk_changeDiscount } = useMainKeeper(
        dropboxes.viewOfOrganization.values[dropboxes.viewOfOrganization.currentValue].value,
        dropboxes.taxationSystem.values[dropboxes.taxationSystem.currentValue].value,
        dropboxes.mainKeeperMove.values[dropboxes.mainKeeperMove.currentValue].value,
        dropboxes.megaPriceOfCountDocuments.currentValue,
        dropboxes.typeActivity.currentValue,
        (diff) => {
            let newDropboxes = {...dropboxes};
            newDropboxes.typeActivity.values = diff.filter(diff => diff.name == "Вид деятельности")[0].param_difficulties;
            newDropboxes.megaPriceOfCountDocuments.values = diff.filter(diff => diff.name == "Кол-во документов")[0].param_difficulties;
            setDropboxes(newDropboxes);
        }
    );
    
    const [prIsMe, setPr] = useState(true);
    const [prIsInner, setPrInner] = useState(true);
    const { pr_summ, pr_changeDiscount } = usePrimary(
        prIsMe,
        prIsInner,
        dropboxes.primaryMegaPriceOfCountDocuments.values[dropboxes.primaryMegaPriceOfCountDocuments.currentValue].value,
        dropboxes.primaryMegaPriceOfTimeLimit.values[dropboxes.primaryMegaPriceOfTimeLimit.currentValue].value,
    );

    const [bankIsMe, setBankIsMe] = useState(true);
    const { bank_summ, bank_changeDiscount } = useBank(
        bankIsMe,
        dropboxes.bankMegaPriceOfStatements.values[dropboxes.bankMegaPriceOfStatements.currentValue].value,
        dropboxes.bankMegaPriceOfTimeLimit.values[dropboxes.bankMegaPriceOfTimeLimit.currentValue].value,
    )

    const [paydayCount, setPayday] = useState(0);
    const { payday_summ, payday_changeDiscount } = usePayday(paydayCount);

    const { rate_tasks, rate_summ, loanSumm, setRateValue, rate_changeDiscount } = useRateOptions(dropboxes.loans.values[dropboxes.loans.currentValue].value);

    const [ftaImport, setFtaImport] = useState(true);
    const [isEAEU, setEAEU] = useState(true);
    const [ftaIsMe, setFta] = useState(true);
    const { fta_summ, fta_changeDiscount } = useFta(
        ftaImport, 
        ftaIsMe,
        isEAEU,
        dropboxes.ftaMegaPriceOfCountDocuments.values[dropboxes.ftaMegaPriceOfCountDocuments.currentValue].value, 
        dropboxes.fatMegaPriceOfTimeLimit.values[dropboxes.fatMegaPriceOfTimeLimit.currentValue].value
    );

    useEffect(() => {
        store.setCalcSumm(Math.ceil(mk_summ + pr_summ + bank_summ + payday_summ + rate_summ + loanSumm + fta_summ));
    }, [mk_summ, pr_summ, bank_summ, payday_summ, rate_summ, loanSumm, fta_summ]);

    useEffect(() => {
        if (store.userInfo == undefined || store.userInfo.discount == undefined || store.userInfo.discountStatus == undefined) return;
        let serverDiscount = store.userInfo.discount * (store.userInfo.discountStatus ? -1 : 1);
        mk_changeDiscount(serverDiscount);
        pr_changeDiscount(serverDiscount);
        bank_changeDiscount(serverDiscount);
        payday_changeDiscount(serverDiscount);
        rate_changeDiscount(serverDiscount);
        fta_changeDiscount(serverDiscount);
    }, [store.userInfo.discount, store.userInfo.discountStatus]);

    const formatNumber = (num) => {
        if (!num) return 0;
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <div className="calculatorContentBlock">
            <div className="baseBlock">
                <div className="blockTitle">
                    <div className="value">База</div>
                    <div className="price">
                        <div className="text">Итого:</div>
                        <div className="summ">{formatNumber(Math.ceil(mk_summ + pr_summ + bank_summ + payday_summ))} ₽</div>
                    </div>
                </div>
                <div className="row">
                    <div className="mainKeeper_block">
                        <div className="title">Задачи ГБ</div>
                        <ul className="content">
                            <li className="mathRow">
                                <div className="math_title">
                                    <Dropbox 
                                        textValue={dropboxes.viewOfOrganization.values[dropboxes.viewOfOrganization.currentValue].name}
                                        isRight={false}
                                        isOpen={dropboxes.viewOfOrganization.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("viewOfOrganization", value)}
                                    >
                                        {dropboxes.viewOfOrganization.values.map((item, index) => <li 
                                            className={dropboxes.viewOfOrganization.currentValue === index ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("viewOfOrganization", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox> на <Dropbox
                                        textValue={dropboxes.taxationSystem.values[dropboxes.taxationSystem.currentValue].name}
                                        isRight={false}
                                        isOpen={dropboxes.taxationSystem.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("taxationSystem", value)}
                                    >
                                        {dropboxes.taxationSystem.values.map((item, index) => <li 
                                            className={dropboxes.taxationSystem.currentValue === index ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("taxationSystem", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox>
                                </div>
                                <div className="math_price">
                                    {/* <div className="params">
                                        <Dropbox
                                            textValue={dropboxes.mainKeeperMove.values[dropboxes.mainKeeperMove.currentValue].name}
                                            isRight={true}
                                            isOpen={dropboxes.mainKeeperMove.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("mainKeeperMove", value)}
                                        >
                                            {dropboxes.mainKeeperMove.values.map((item, index) => <li 
                                                className={dropboxes.mainKeeperMove.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("mainKeeperMove", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>
                                    </div> */}
                                    <div className="value">{formatNumber(mk_orgranization)} ₽</div>
                                </div>
                            </li>
                            <li className="mathRow">
                                <div className="math_title">Надбавка за кол-во документов</div>
                                <div className="math_price">
                                    <div className="params">{dropboxes.megaPriceOfCountDocuments.values && dropboxes.megaPriceOfCountDocuments.values.length > 0 && <Dropbox
                                        textValue={dropboxes.megaPriceOfCountDocuments.values[dropboxes.megaPriceOfCountDocuments.currentValue].name}
                                        isRight={true}
                                        isOpen={dropboxes.megaPriceOfCountDocuments.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("megaPriceOfCountDocuments", value)}
                                    >
                                        {dropboxes.megaPriceOfCountDocuments.values.map((item, index) => <li 
                                            className={dropboxes.megaPriceOfCountDocuments.currentValue === index ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("megaPriceOfCountDocuments", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox>}</div>
                                    <div className="value">{formatNumber(mk_difficulty_docs)} ₽</div>
                                </div>
                            </li>
                            <li className="mathRow">
                                <div className="math_title">Надбавка за вид деятельности</div>
                                <div className="math_price">
                                    <div className="params">{dropboxes.typeActivity.values && dropboxes.typeActivity.values.length > 0 && <Dropbox
                                        textValue={dropboxes.typeActivity.values[dropboxes.typeActivity.currentValue].name}
                                        isRight={true}
                                        isOpen={dropboxes.typeActivity.isOpened}
                                        changeOpened={(value) => changeOpenedDropbox("typeActivity", value)}
                                    >
                                        {dropboxes.typeActivity.values.map((item, index) => <li 
                                            className={dropboxes.typeActivity.currentValue === index ? "selected" : ""}
                                            key={item+index}
                                            onClick={() => changeValueDropbox("typeActivity", index)}
                                        >
                                            <div className="number">{index+1}.</div>
                                            <div className="value">{item.name}</div>
                                        </li>)}
                                    </Dropbox>}</div>
                                    <div className="value">{formatNumber(mk_difficulty_activity)} ₽</div>
                                </div>
                            </li>
                        </ul>
                        <div className="moneySumm">
                            <button className="activeButton" onClick={() => window.location.href="/calc/mainkeeper"}>Изменить</button>
                            <div className="summ">
                                <div className="text">Итого:</div>
                                <div className="value">{formatNumber(mk_summ)} ₽</div>
                            </div>
                        </div>
                    </div>
                    <div className="primary_block">
                        <div className="title">
                            <div className="text">Первичка</div>
                            <MultiSwitcherStage
                                values={[
                                    { name: "Входящая", value: true },
                                    { name: "Исходящая", value: false },
                                ]}
                                selectValue={(newValue) => setPrInner(newValue == 0 ? true : false)}
                                defaultValue={prIsInner ? 0 : 1}
                                forceSelected={prIsInner ? 0 : 1}
                            />
                        </div>
                        <ul className="content">
                            <li className="mathRow">
                                <div className="math_title">Кто вносит первичку</div>
                                <div className="math_price">
                                    <div className="params"><SwitcherParams name1="Мы" name2="Клиент" onChangeValue={(value) => setPr(value ? false : true)}/></div>
                                </div>
                            </li>
                            <li className="mathRow">
                                <div className="math_title">Надбавка за кол-во документов</div>
                                <div className="math_price">
                                    <div className="params">
                                        <Dropbox
                                            textValue={dropboxes.primaryMegaPriceOfCountDocuments.values[dropboxes.primaryMegaPriceOfCountDocuments.currentValue].name}
                                            isRight={true}
                                            isOpen={dropboxes.primaryMegaPriceOfCountDocuments.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("primaryMegaPriceOfCountDocuments", value)}
                                        >
                                            {dropboxes.primaryMegaPriceOfCountDocuments.values.map((item, index) => <li 
                                                className={dropboxes.primaryMegaPriceOfCountDocuments.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("primaryMegaPriceOfCountDocuments", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>
                                    </div>
                                </div>
                            </li>
                            <li className="mathRow">
                                <div className="math_title">Надбавка за вид деятельности</div>
                                <div className="math_price">
                                    <div className="params">
                                        <Dropbox
                                            textValue={dropboxes.primaryMegaPriceOfTimeLimit.values[dropboxes.primaryMegaPriceOfTimeLimit.currentValue].name}
                                            isRight={true}
                                            isOpen={dropboxes.primaryMegaPriceOfTimeLimit.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("primaryMegaPriceOfTimeLimit", value)}
                                        >
                                            {dropboxes.primaryMegaPriceOfTimeLimit.values.map((item, index) => <li 
                                                className={dropboxes.primaryMegaPriceOfTimeLimit.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("primaryMegaPriceOfTimeLimit", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="moneySumm">
                            <button className="activeButton" onClick={() => window.location.href="/calc/primary"}>Изменить</button>
                            <div className="summ">
                                <div className="text">Итого:</div>
                                <div className="value">{formatNumber(pr_summ)} ₽</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="bank_block">
                        <div className="title">Банк</div>
                        <ul className="content">
                            <li className="mathRow">
                                <div className="math_title">Кто вносит банк</div>
                                <div className="math_price">
                                    <div className="params"><SwitcherParams name1="Мы" name2="Клиент" onChangeValue={(value) => setBankIsMe(value ? false : true)}/></div>
                                    {/* <div className="value">9 500 ₽</div> */}
                                </div>
                            </li>
                            <li className="mathRow_multi">
                                <div className="rows">
                                    <div>
                                        <div className="math_title">Кол-во строк выписки</div>
                                        <div className="params">
                                            <Dropbox
                                                textValue={dropboxes.bankMegaPriceOfStatements.values[dropboxes.bankMegaPriceOfStatements.currentValue].name}
                                                isRight={true}
                                                isOpen={dropboxes.bankMegaPriceOfStatements.isOpened}
                                                changeOpened={(value) => changeOpenedDropbox("bankMegaPriceOfStatements", value)}
                                            >
                                                {dropboxes.bankMegaPriceOfStatements.values.map((item, index) => <li 
                                                    className={dropboxes.bankMegaPriceOfStatements.currentValue === index ? "selected" : ""}
                                                    key={item+index}
                                                    onClick={() => changeValueDropbox("bankMegaPriceOfStatements", index)}
                                                >
                                                    <div className="number">{index+1}.</div>
                                                    <div className="value">{item.name}</div>
                                                </li>)}
                                            </Dropbox>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="math_title">Кол-во загрузок выписки из банка в месяц</div>
                                        <div className="params">
                                            <Dropbox
                                                textValue={dropboxes.bankMegaPriceOfTimeLimit.values[dropboxes.bankMegaPriceOfTimeLimit.currentValue].name}
                                                isRight={true}
                                                isOpen={dropboxes.bankMegaPriceOfTimeLimit.isOpened}
                                                changeOpened={(value) => changeOpenedDropbox("bankMegaPriceOfTimeLimit", value)}
                                            >
                                                {dropboxes.bankMegaPriceOfTimeLimit.values.map((item, index) => <li 
                                                    className={dropboxes.bankMegaPriceOfTimeLimit.currentValue === index ? "selected" : ""}
                                                    key={item+index}
                                                    onClick={() => changeValueDropbox("bankMegaPriceOfTimeLimit", index)}
                                                >
                                                    <div className="number">{index+1}.</div>
                                                    <div className="value">{item.name}</div>
                                                </li>)}
                                            </Dropbox>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="summ">
                                    <div className="value">12 270 ₽</div>
                                </div> */}
                            </li>
                        </ul>
                        <div className="moneySumm">
                            <button className="activeButton" onClick={() => window.location.href="/calc/bank"}>Изменить</button>
                            <div className="summ">
                                <div className="text">Итого:</div>
                                <div className="value">{formatNumber(bank_summ)} ₽</div>
                            </div>
                        </div>
                    </div>
                    <div className="payday_block">
                        <div className="title">Зарпалата</div>
                        <ul className="content">
                            <li className="mathRow">
                                <div className="math_title">Диапазон количества сотрудников</div>
                                <div className="math_price">
                                    <div className="params">
                                        <Clicker
                                            isDecimal={true}
                                            step={1}
                                            value={paydayCount}
                                            setValue={(newValue) => setPayday(newValue)}
                                        />
                                    </div>
                                    {/* <div className="value"></div> */}
                                </div>
                            </li>
                        </ul>
                        <div className="moneySumm">
                            <button className="activeButton" onClick={() => window.location.href="/calc/payday"}>Изменить</button>
                            <div className="summ">
                                <div className="text">Итого:</div>
                                <div className="value">{formatNumber(payday_summ)} ₽</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="secondBlock">
                <div className="rateOptionsBlock">
                    <div className="blockTitle">
                        <div className="value">Тарифные опции</div>
                        <div className="price">
                            <div className="text">Итого:</div>
                            <div className="summ">{formatNumber(Math.ceil(rate_summ + loanSumm))} ₽</div>
                        </div>
                    </div>
                    <div className="blockContent">
                        <ul className="mathRow_list">
                            <li>
                                <div className="math_title">Займы</div>
                                <div className="math_price">
                                    <div className="params">
                                        <Dropbox 
                                            textValue={dropboxes.loans.values[dropboxes.loans.currentValue].name}
                                            isRight={true}
                                            isOpen={dropboxes.loans.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("loans", value)}
                                        >
                                            {dropboxes.loans.values.map((item, index) => <li 
                                                className={dropboxes.loans.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("loans", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>
                                    </div>
                                    <div className="value">{formatNumber(loanSumm)} ₽</div>
                                </div>
                            </li>
                            {rate_tasks && rate_tasks.length > 0 && rate_tasks.map((task, index) => 
                                <li key={task+index}>
                                    <div className="math_title">{task.name}</div>
                                    <div className="math_price">
                                        <div className="params">{task.isMulti
                                                ? <Clicker 
                                                    min={0} 
                                                    setValue={(newValue) => setRateValue(index, newValue)} 
                                                    value={task.value} 
                                                    step={1} 
                                                    isDecimal={true}
                                                />
                                                : <SwitcherParams 
                                                    name1="Нет" 
                                                    name2="Да" 
                                                    onChangeValue={(isActive) => setRateValue(index, isActive ? 1 : 0)}
                                                />    
                                            }</div>
                                        <div className="value">{formatNumber(task.isMulti ? Math.ceil(task.value * task.cost) : (task.value == 1 ? task.cost : 0))} ₽</div>
                                    </div>
                                </li>
                            )}
                        </ul>
                        <div className="moneySumm">
                            <button className="activeButton" onClick={() => window.location.href="/calc/rateoptions"}>Изменить</button>
                            <div className="summ">
                                <div className="text">Итого:</div>
                                <div className="value">{formatNumber(Math.ceil(rate_summ + loanSumm))} ₽</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="FatBlock">
                    <div className="blockTitle">
                        <div className="value">ВЭД</div>
                        <div className="price">
                            <div className="text">Итого:</div>
                            <div className="summ">{formatNumber(fta_summ)} ₽</div>
                        </div>
                    </div>
                    <div className="blockContent">
                        <div className="title">
                            <div className="text">{ftaImport?"Импорт":"Экспорт"}</div>
                            <MultiSwitcherStage
                                values={[{ name: 'Импорт' }, { name: 'Экспорт' }]}
                                selectValue={(newValue) => setFtaImport(newValue == 0 ? true : false)}
                                defaultValue={ftaImport ? 0 : 1}
                                forceSelected={ftaImport ? 0 : 1}
                            />
                        </div>
                        <ul className="content">
                            <li className="mathRow">
                                <div className="math_title">Кто вносит</div>
                                <div className="math_price">
                                    <div className="params"><SwitcherParams name1="Мы" name2="Клиент" onChangeValue={(value) => setFta(!value)}/></div>
                                </div>
                            </li>
                            <li className="mathRow">
                                <div className="math_title">Расчёт ЕАЭС</div>
                                <div className="math_price">
                                    <div className="params"><SwitcherParams name1="Да" name2="Нет" onChangeValue={(value) => setEAEU(!value)}/></div>
                                </div>
                            </li>
                            <li className="mathRow">
                                <div className="math_title">Диапазон кол-ва документов</div>
                                <div className="math_price">
                                    <div className="params">
                                        <Dropbox
                                            textValue={dropboxes.ftaMegaPriceOfCountDocuments.values[dropboxes.ftaMegaPriceOfCountDocuments.currentValue].name}
                                            isRight={true}
                                            isOpen={dropboxes.ftaMegaPriceOfCountDocuments.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("ftaMegaPriceOfCountDocuments", value)}
                                        >
                                            {dropboxes.ftaMegaPriceOfCountDocuments.values.map((item, index) => <li 
                                                className={dropboxes.ftaMegaPriceOfCountDocuments.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("ftaMegaPriceOfCountDocuments", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>
                                    </div>
                                </div>
                            </li>
                            <li className="mathRow">
                                <div className="math_title">Время внесения</div>
                                <div className="math_price">
                                    <div className="params">
                                        <Dropbox
                                            textValue={dropboxes.fatMegaPriceOfTimeLimit.values[dropboxes.fatMegaPriceOfTimeLimit.currentValue].name}
                                            isRight={true}
                                            isOpen={dropboxes.fatMegaPriceOfTimeLimit.isOpened}
                                            changeOpened={(value) => changeOpenedDropbox("fatMegaPriceOfTimeLimit", value)}
                                        >
                                            {dropboxes.fatMegaPriceOfTimeLimit.values.map((item, index) => <li 
                                                className={dropboxes.fatMegaPriceOfTimeLimit.currentValue === index ? "selected" : ""}
                                                key={item+index}
                                                onClick={() => changeValueDropbox("fatMegaPriceOfTimeLimit", index)}
                                            >
                                                <div className="number">{index+1}.</div>
                                                <div className="value">{item.name}</div>
                                            </li>)}
                                        </Dropbox>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="moneySumm">
                            <button className="activeButton" onClick={() => window.location.href="/calc/fta"}>Изменить</button>
                            <div className="summ">
                                <div className="text">Итого:</div>
                                <div className="value">{formatNumber(fta_summ)} ₽</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(Calculator);
